import React from 'react'
import { Button } from '@mui/material'
import { PRIMARY_COLOR } from '../colorPalette'

const styles = {
  filledButton: {
    backgroundColor: PRIMARY_COLOR,
    color: '#F7F7F7',
    borderRadius: '30px',
    textTransform: 'none',
    width: '250px',
    height: '60px',
    padding: '15px 0',
    fontSize: '18px',
  },
}

function RoundedFilledButton({children, onClick, customStyles, ...props}) {
    return (
        <Button {...props} onClick={onClick} variant="outlined" style={{...styles.filledButton, ...customStyles}}>
          {children}
        </Button>
    )
}

export default RoundedFilledButton